module.exports = __webpack_public_path__ + "img/Receiving.5271a61d.png";